import * as React from 'react';
import { StyledButtonGroupDiv } from './styledButtonGroupDiv';
import { BreakpointType } from '../../constants/types';
import { ButtonProps } from '../button/Button';

export interface ButtonGroupProps {
  breakpoint?: BreakpointType;
  children: React.ReactElement<ButtonProps> | React.ReactElement<ButtonProps>[];
}

const ButtonGroup: React.SFC<ButtonGroupProps> = ({ children, breakpoint = 'md' }) => {
  return <StyledButtonGroupDiv breakpoint={breakpoint}>{children}</StyledButtonGroupDiv>;
};

export default ButtonGroup;
